export { DocumentIcon } from "./DocumentIcon";
